import { ReviewCarousel } from "./ReviewCarousel";
import { ToastContainer } from "./Toast";

export function ReviewWidget() {
  return (
    <>
      <ReviewCarousel />
      <ToastContainer />
    </>
  );
}
